import React, { PropTypes, PureComponent } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import { FormattedMessage } from '@dbk-legacy/format';
import Modal from '@dbk/ui-modal';
import BlurModal from '../../../components/common/blur-modal';
import VascoLock from './vasco-lock';
import Vasco from './vasco';
import VascoNotActivated from './vasco-not-activated';
import {
  VASCO_STATUSES,
  VASCO_FLOW,
  VASCO_MODAL_TYPES,
  ROUTES
} from '../../../constants';
import NtbModal from '../ntb-modal/ntb-modal';

class VascoModal extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      title: '',
    };
    this.onVascoDone = this.onVascoDone.bind(this);
  }

  onVascoDone() {
    this.props.vascoauthentication.onHideVasco();
    if (this.props.vascoauthentication.vascoModalType === VASCO_MODAL_TYPES.failUserLocked || this.props.vascoauthentication.vascoModalType ===VASCO_MODAL_TYPES.failExceededOtp){
      this.props.auth.logOut('/login');
    } else if (this.props.vascoauthentication.vascoModalType === VASCO_MODAL_TYPES.notActivated || this.props.vascoauthentication.vascoModalType === VASCO_MODAL_TYPES.ntbUser){
      window.location.reload();
    } else if(this.props.vascoauthentication.vascoModalType === VASCO_MODAL_TYPES.pin2fa && !this.props.hrmw.isManageContactDetails){
      this.props.auth.setLogoutConfirmVisible(true);
    } else if(this.props.vascoauthentication.vascoModalType === VASCO_MODAL_TYPES.pin2fa && this.props.hrmw.isManageContactDetails){
      this.props.setManageContactDetails(false);
      this.props.changePage(ROUTES.PROFILE.MANAGE_CONTACT_DETAILS_ROUTE);
    }
  }

  async onLogOut() {
    this.setState({ isLoading: true });
    await this.props.logout();
    this.setState({ isLoading: false });
  }

  closeModal = () => {
    this.props.vascoauthentication.onHideVasco();
    this.props.vascoauthentication.setVascoModalType(null);
  }
  
  renderModal() {
    const {
      i18n: { messages },
    } = this.props;
    if (
      this.props.vascoauthentication.vascoModalType === VASCO_MODAL_TYPES.pin2fa
    ) {
      this.setState({
        title: messages['app.vasco.ch.web.title.otp'],
      });
      return <Vasco />;
    }

    if (
      this.props.vascoauthentication.vascoModalType ===
        VASCO_MODAL_TYPES.notActivated &&
      !this.props.auth.passwordExpired &&
      this.props.auth.entitlementProcessed
    ) {
      this.setState({
        title: messages["app.auth.ntbModal.header"]
      });
      return <NtbModal closeModal={this.closeModal}/>
    }

    if (
      this.props.vascoauthentication.vascoModalType ===
      VASCO_MODAL_TYPES.failUserLocked
    ) {
      this.setState({
        title: messages['app.auth.vasco.authentication.userLocked.title'],
      });
      return (
        <VascoLock instructionsMsgId="app.vasco.instructions.userLocked.message" />
      );
    }
    if (
      this.props.vascoauthentication.vascoModalType ===
      VASCO_MODAL_TYPES.failExceededOtp
    ) {
      this.setState({
        title: messages['app.vasco.ch.instructions.userLocked'],
      });
      return (
        <VascoLock instructionsMsgId="app.vasco.ch.instructions.exceeded" />
      );
    }
    if(this.props.vascoauthentication.vascoModalType === VASCO_MODAL_TYPES.ntbUser){
      this.setState({
        title: messages["app.auth.ntbModal.header"]
      });
      return <NtbModal closeModal={this.closeModal}/>
    }
  }

  render() {
    const {
      i18n: { messages },
      vascoauthentication: { vascoModalType },
    } = this.props;
    const doneLabel = messages['app.common.closeText'];
    const titleId = 'app.token.header.title';
    this.props.setManageContactDetailsMcd(false);
    this.props.setAISAccountConfirmation(false);
    return (
      <div>
        <BlurModal
          hasHeader
          title={this.state.title}
          visible={this.props.vascoauthentication.vascoVisible}
          onDone={this.onVascoDone}
          disableOutsideClick={ true }
          doneLabel={doneLabel}
          doneVisible={true}
          size={'large'}
          className={ vascoModalType === VASCO_MODAL_TYPES.ntbUser || (this.props.vascoauthentication.vascoModalType ===
            VASCO_MODAL_TYPES.notActivated &&
          !this.props.auth.passwordExpired &&
          this.props.auth.entitlementProcessed) ? "ntb-modal" : "model-window-login"}
        >
          {this.renderModal()}
        </BlurModal>
      </div>
    );
  }
}

export default createContainer({
  $queries: {
    logout: { $call: 'auth.logout' },
    vascoauthentication: {
      onChangePage: { $call: 'vascoChangePage' },
      onHideVasco: { $call: 'hideVasco' },
      otpStatus: true,
      vascoVisible: true,
      vascoAuthorised: true,
      vascoModalType: true,
      isNTB: true,
      onHideVasco: { $call: 'hideVasco' },
      setVascoModalType: { $set: 'vascoModalType'}
    },
    auth: {
      logOut: { $call: 'logout' },
      passwordExpired: true,
      entitlementProcessed: true,
      setLogoutConfirmVisible:{$call: 'setLogoutConfirmVisible'}
    },
    i18n: {
      messages: true,
    },
    changePage: { $call: 'ui.history.push' },
    hrmw: {
      isManageContactDetails: true,
      getContactDetailsListData: { $call: 'getContactDetailsListData'},
    },
    setManageContactDetails:{ $set: 'hrmw.isManageContactDetails'},
    setManageContactDetailsMcd:{ $set: 'hrmw.isManageContactDetailsMcd'},
    setAISAccountConfirmation: { $set: 'ais.isAccountConfirmation'}
  },
})(VascoModal);
